import { useSellerListings } from "./useListings";

/**
 * The given API contract only exposes `GET /api/v1/seller/listings` (a list) — there is no
 * documented single-listing seller endpoint, and the public `GET /listings/:id` is
 * published-only, so it can't be used to fetch a seller's own DRAFT/SCANNING/REJECTED
 * listing. This derives a single listing by filtering the seller's own list client-side.
 * If apps/api later adds `GET /seller/listings/:id`, swap this for a direct query.
 */
export function useSellerListing(id: string | undefined) {
  const query = useSellerListings(Boolean(id));
  const listing = query.data?.items.find((item) => item.id === id) ?? null;
  return { ...query, listing };
}
